// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_M6loR","icon":"index_icon_Z7Hjw"};